module.exports = __webpack_public_path__ + "fonts/Gilroy-100.7f7d086.otf";